import { Grid } from '@mui/material';
import { isEmpty } from 'lodash-es';
import { WsTypography, WsTypoVariants } from 'wisestep-base';

import { useComposableDashboardsFiltersContext } from '../../../../features/analyticsPage/hooks/useComposableDashboardsFiltersContext';
import { useComposableDynamicListingContext } from '../../../../features/analyticsPage/hooks/useComposableDynamicListingContext';
import CountWithTextCard from '../../../analytics/components/countWithTextCard';
import { LeadWidget } from '../../DerivedCharts/helper';
import { ILeadDTO } from '../jobs/types/postgreJobsDTO';
import { ILeadWidgetProp } from '../jobs/types/postgreJobsWidgetProp';

import { renderLeadCountCell } from './leadDrillDownHelper';
import { defaultLeadWidgetData } from './leadHelper';
import usePostgreLeadWidgetsData from './useLeadWidgetData';

const LeadCountMetric = ({ query, title, widgetName }: ILeadWidgetProp) => {
  const { widgetData } = usePostgreLeadWidgetsData<ILeadDTO>(query, defaultLeadWidgetData);
  const { restructuredFilters } = useComposableDashboardsFiltersContext();
  const { leadStatusList } = useComposableDynamicListingContext();
  const getLeadStatusIdByName = (label: string): string | undefined => {
    return leadStatusList?.find((item) => item.label === label)?.value;
  };
  return (
    <Grid container p={2}>
      <Grid item xs={12} mb={2}>
        <WsTypography variant={WsTypoVariants.TITLE} bold={true}>
          {title}
        </WsTypography>
      </Grid>
      {!widgetData.countByStatus && (
        <Grid item xs={2} ml={10}>
          <CountWithTextCard
            variant="h3"
            count={
              renderLeadCountCell(
                { value: widgetData.count ?? 0 },
                widgetName == LeadWidget.METRIC_OWNED ? [['METRIC_OWNED', 'is_owned']] : [],
                restructuredFilters,
                query
              ) as any
            }
            fullHeight
            text=""
          />
        </Grid>
      )}
      {widgetData.countByStatus && isEmpty(widgetData.countByStatus) ? (
        <Grid item xs={2} ml={10}>
          <CountWithTextCard variant="h3" count={0} fullHeight text="" />
        </Grid>
      ) : (
        Object.keys(widgetData.countByStatus ?? {}).map((leadStatus) => (
          <Grid item key={leadStatus} xs={1} ml={10}>
            <CountWithTextCard
              variant="h4"
              count={
                renderLeadCountCell(
                  { value: widgetData.countByStatus?.[leadStatus] ?? 0 },
                  widgetName == LeadWidget.METRIC_OWNED_BY_STATUS
                    ? [
                        ['LEAD_STATUS_ID', getLeadStatusIdByName(leadStatus) ?? ''],
                        ['METRIC_OWNED_BY_STATUS', 'lead_owned'],
                      ]
                    : widgetName == LeadWidget.METRIC_UPDATED_BY_STATUS
                    ? [
                        ['LEAD_STATUS_ID', getLeadStatusIdByName(leadStatus) ?? ''],
                        ['METRIC_UPDATED_BY_STATUS', 'lead_updated'],
                      ]
                    : [['LEAD_STATUS_ID', getLeadStatusIdByName(leadStatus) ?? '']],
                  restructuredFilters,
                  query
                ) as any
              }
              fullHeight
              text={leadStatus}
              textVariant="caption"
            />
          </Grid>
        ))
      )}
    </Grid>
  );
};

export default LeadCountMetric;
